import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

interface OutcomeCellProps {
  backgroundColor: string
  title?: string
}

type StyledOutcomeCellProps = Pick<OutcomeCellProps, 'backgroundColor'>

const StyledOutcomeCell = styled.div<StyledOutcomeCellProps>`
  ${({ backgroundColor }) => {
    return css`
      width: 4px;
      height: 100%;
      background-color: ${backgroundColor};
    `
  }}
`

const OutcomeCell: FunctionComponent<OutcomeCellProps> = ({
  backgroundColor,
  title,
}) => {
  return (
    <StyledOutcomeCell
      {...(title ? { title } : {})}
      backgroundColor={backgroundColor}
    />
  )
}

export default OutcomeCell
